import { useState } from 'react';
  import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow
  } from '@mui/material';
  import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
  import { SiteVisitCard, SiteVisitContainer } from '../../../components/site-visit-details/styled-components';
  import { SiteVisitTitleContainer, StyledButton } from '../styled-components';
  import GuidelinesDialog from '../../../components/checkout-comment-dialog/guidelines-dialog';
  import { decodeHtmlEntities, isCpAppSource } from '../../../utils/functions/site-visit-comment';
  import { CustomizedText } from '../../../components/styled-componnets';
  import { useTranslation } from "react-i18next";
  import moment from 'moment';
  
  const SiteVisitTable = ({ data, source }: { data: any[]; source?: string }) => {
    const { t } = useTranslation();
    const [isGuidelinesOpen, setIsGuidelinesOpen] = useState(false);
    const isCp = isCpAppSource(source);
  
    const renderTitle = () => (
      <CustomizedText fontSize={28} gutterBottom font={"Lato-Regular"}>
        {t("opportunity_details.site_visit_table_title")}
      </CustomizedText>
    );
  
    const formatDate = (dateStr: string) => {
      return moment(dateStr).isValid() ? moment(dateStr).format("DD/MM/YY") : dateStr;
    };
  
    const formatTime = (timeStr: string) => {
      const cleanTime = timeStr?.split('.')[0]; // remove microseconds
      return moment(cleanTime, "HH:mm").isValid()
        ? moment(cleanTime, "HH:mm").format("hh:mm A")
        : timeStr;
    };
  
    return (
      <SiteVisitContainer>
        <SiteVisitTitleContainer sx={{ pl: 0, pr: 0 }}>
          {renderTitle()}
          <StyledButton
            sx={{ pt: 0.5, pb: 0.5 }}
            startIcon={<InfoOutlinedIcon />}
            onClick={() => setIsGuidelinesOpen(true)}
          >
            {t("site_visit_comment.guidelines.button")}
          </StyledButton>
        </SiteVisitTitleContainer>
        <GuidelinesDialog open={isGuidelinesOpen} onClose={() => setIsGuidelinesOpen(false)} isCp={isCp} />
        <SiteVisitCard>
          <TableContainer sx={{ maxHeight: 400, mt: 2 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                    <CustomizedText fontSize={19}>
                      {t("opportunity_details.site_visit_table.no")}
                    </CustomizedText>
                  </TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                    <CustomizedText fontSize={19}>
                      {t("opportunity_details.site_visit_table.site_visit_date")}
                    </CustomizedText>
                  </TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                    <CustomizedText fontSize={19}>
                      {t("opportunity_details.site_visit_table.site_visit_time")}
                    </CustomizedText>
                  </TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                    <CustomizedText fontSize={19}>
                      {t("opportunity_details.site_visit_table.check_out_time")}
                    </CustomizedText>
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>
                    <CustomizedText fontSize={19}>
                      {t("opportunity_details.site_visit_table.site_visit_comment")}
                    </CustomizedText>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <CustomizedText fontSize={18}>{index + 1}</CustomizedText>
                    </TableCell>
                    <TableCell>
                      <CustomizedText fontSize={18}>{formatDate(row.site_visit_date)}</CustomizedText>
                    </TableCell>
                    <TableCell>
                      <CustomizedText fontSize={18}>{formatTime(row.site_visit_time)}</CustomizedText>
                    </TableCell>
                    <TableCell>
                      <CustomizedText fontSize={18}>{formatTime(row.site_visit_out_time)}</CustomizedText>
                    </TableCell>
                    <TableCell
                      sx={{
                        whiteSpace: 'pre-line',
                        wordBreak: 'break-word',
                        maxWidth: 300
                      }}
                    >
                      <CustomizedText fontSize={18}>{decodeHtmlEntities(row.site_visit_comment)}</CustomizedText>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </SiteVisitCard>
      </SiteVisitContainer>
    );
  };
  
  export default SiteVisitTable;
  